import React from "react";
import { Grid, FormControlLabel, Checkbox, Button } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
    certificateOfIncorporationImage: Yup.bool().oneOf([true], "Certificate of Incorporation is required"),
    tradeBusinessProof: Yup.bool().oneOf([true], "Trade Business Proof is required"),
    cancelledChequeImages: Yup.bool().oneOf([true], "Cancelled Cheque Images is required"),
    physicalVerification: Yup.bool().oneOf([true], "Physical Verification is required"),
    videoKycWithLatLongData: Yup.bool().oneOf([true], "Video KYC with Location Data is required"),
    shopAndPanImage: Yup.bool().oneOf([true], "Shop and PAN Image is required"),
    backgroundImageOfShop: Yup.bool().oneOf([true], "Shop Background Image is required"),
    termsConditionCheck: Yup.bool().oneOf([true], "You must accept the Terms & Conditions").required("Required"),
});

const Verification = ({ initialValues, onNext, onBack }) => {
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => onNext(values)}
        >
            {({ values, errors, touched, setFieldValue }) => (
                <Form>
                    <Grid container spacing={2}>
                        {/* Certificate of Incorporation */}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="certificateOfIncorporationImage"
                                        checked={values.certificateOfIncorporationImage}
                                        onChange={() => setFieldValue("certificateOfIncorporationImage", !values.certificateOfIncorporationImage)}
                                    />
                                }
                                label="Certificate of Incorporation"
                            />
                            {errors.certificateOfIncorporationImage && touched.certificateOfIncorporationImage && (
                                <div style={{ color: "red", fontSize: "0.8rem" }}>{errors.certificateOfIncorporationImage}</div>
                            )}
                        </Grid>
                        {/* Trade Business Proof */}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="tradeBusinessProof"
                                        checked={values.tradeBusinessProof}
                                        onChange={() => setFieldValue("tradeBusinessProof", !values.tradeBusinessProof)}
                                    />
                                }
                                label="Trade Business Proof"
                            />
                            {errors.tradeBusinessProof && touched.tradeBusinessProof && (
                                <div style={{ color: "red", fontSize: "0.8rem" }}>{errors.tradeBusinessProof}</div>
                            )}
                        </Grid>
                        {/* Cancelled Cheque Images */}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="cancelledChequeImages"
                                        checked={values.cancelledChequeImages}
                                        onChange={() => setFieldValue("cancelledChequeImages", !values.cancelledChequeImages)}
                                    />
                                }
                                label="Cancelled Cheque Images"
                            />
                            {errors.cancelledChequeImages && touched.cancelledChequeImages && (
                                <div style={{ color: "red", fontSize: "0.8rem" }}>{errors.cancelledChequeImages}</div>
                            )}
                        </Grid>
                        {/* Physical Verification */}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="physicalVerification"
                                        checked={values.physicalVerification}
                                        onChange={() => setFieldValue("physicalVerification", !values.physicalVerification)}
                                    />
                                }
                                label="Physical Verification"
                            />
                            {errors.physicalVerification && touched.physicalVerification && (
                                <div style={{ color: "red", fontSize: "0.8rem" }}>{errors.physicalVerification}</div>
                            )}
                        </Grid>
                        {/* Video KYC with Location Data */}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="videoKycWithLatLongData"
                                        checked={values.videoKycWithLatLongData}
                                        onChange={() => setFieldValue("videoKycWithLatLongData", !values.videoKycWithLatLongData)}
                                    />
                                }
                                label="Video KYC with Location Data"
                            />
                            {errors.videoKycWithLatLongData && touched.videoKycWithLatLongData && (
                                <div style={{ color: "red", fontSize: "0.8rem" }}>{errors.videoKycWithLatLongData}</div>
                            )}
                        </Grid>
                        {/* Shop and PAN Image */}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="shopAndPanImage"
                                        checked={values.shopAndPanImage}
                                        onChange={() => setFieldValue("shopAndPanImage", !values.shopAndPanImage)}
                                    />
                                }
                                label="Shop and PAN Image"
                            />
                            {errors.shopAndPanImage && touched.shopAndPanImage && (
                                <div style={{ color: "red", fontSize: "0.8rem" }}>{errors.shopAndPanImage}</div>
                            )}
                        </Grid>
                        {/* Shop Background Image */}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="backgroundImageOfShop"
                                        checked={values.backgroundImageOfShop}
                                        onChange={() => setFieldValue("backgroundImageOfShop", !values.backgroundImageOfShop)}
                                    />
                                }
                                label="Shop Background Image"
                            />
                            {errors.backgroundImageOfShop && touched.backgroundImageOfShop && (
                                <div style={{ color: "red", fontSize: "0.8rem" }}>{errors.backgroundImageOfShop}</div>
                            )}
                        </Grid>

                        {/* Terms and Conditions Checkbox */}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="termsConditionCheck"
                                        checked={values.termsConditionCheck}
                                        onChange={() => setFieldValue("termsConditionCheck", !values.termsConditionCheck)}
                                    />
                                }
                                label="I accept the Terms & Conditions"
                            />
                            {errors.termsConditionCheck && touched.termsConditionCheck && (
                                <div style={{ color: "red", fontSize: "0.8rem" }}>{errors.termsConditionCheck}</div>
                            )}
                        </Grid>
                    </Grid>
                    <Button variant="contained" color="secondary" sx={{ mt: 2, mr: 2 }} onClick={onBack}>
                        Back
                    </Button>
                    <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
                        Next
                    </Button>
                </Form>
            )}
        </Formik>
    );
};

export default Verification;
